module.exports = __webpack_public_path__ + "img/event-4.a64c66d0.png";